import results from '@/sui/data/results'

const scopes = {
  bact: [
    {
      name: `Indicateurs et catégories`,
      entrances: results.extractEntrances(
        'bact', ['in-ctr', 'in-cvp', '|', 'ctr', 'peri', 'dia', '|', 'all', 'sta', 'stakt'], '#FF9C2D'
      ),
      tooltip: `Taux d'incidence par groupement de porte d'entrée : cathéters
centraux, cathéters périphériques, dialyse et taux global.`
    },
    {
      name: `Cathéters centraux et apparentés`,
      entrances: results.extractEntrances(
        'bact',
        ['cvc', 'cci', 'cvo', 'picc', 'caut', '|', 'cart', 'cao', '|', 'ecmo'], '#9774CC'
      ),
      tooltip: `Taux d'incidence pour les cathéters centraux et apparentés:
${results.entrances.bact.ctr.tooltip}.`
    },
    {
      name: `CVPs courts et MIDlines`,
      entrances: results.extractEntrances(
        'bact', ['mid', 'midap', 'midsp', '|', 'cvp', 'cvpap', 'cvpsp'], '#87FFA1'
      ),
      tooltip: `Taux d'incidence pour les CVPs courts et MIDlines :
${results.entrances.bact.peri.tooltip}.`
    },
    {
      name: `Site d'accès vasculaire de dialyse`,
      entrances: results.extractEntrances('bact', ['cdia', 'fistnat', 'fistpro'], '#c2e234'),
      tooltip: `Taux d'incidence pour les sites d'accès vasculare de dialyse :
${results.entrances.bact.dia.tooltip}.`
    },
    {
      name: `Portes d'entrée urinaire`,
      entrances: results.extractEntrances('bact', ['uri', 'urisa'], '#111c80'),
      tooltip: `Taux d'incidence pour les porte d'entrées urinaire.`,
      year: 2020
    },
    {
      name: `Portes d'entrée non retrouvée`,
      entrances: results.extractEntrances('bact', ['nf', 'nfctr', 'nfperi'], '#e04000'),
      tooltip: `Taux d'incidence pour les portes d'entrées non retrouvées.`,
      year: 2020
    },
    {
      name: 'Aggrégats de cathéters centraux',
      entrances: results.extractEntrances('bact', ['cvc-picc-cdia', 'cvc-cci-picc-cdia', 'cvc-picc-cvo'], '#e52a89'),
      tooltip: `Taux d'incidence pour les aggrégats de cathéters centraux`,
      year: 2020,
      hidden: true
    }
  ],

  pneu: [
    {
      name: `Toutes les porte d'entrées`,
      entrances: results.extractEntrances('pneu', ['pall', 'itb'], '#5bc0de')
    }
  ]
}

const filters = [
  {
    name: 'Toutes les disciplines',
    tooltip: `Affichage des résultats par disciplines.`,
    filter: function (vm, u) {
      return u.uf === '__all__' && u.spe === '__all__'
    }
  },
  {
    name: 'Spécialités de réanimation',
    tooltip: `Affichage des résultats par spécialité de réanimation.`,
    filter: function (vm, u) {
      return u.uf === '__all__' && u.spe.match(/AD REA ./)
    }
  },
  {
    name: 'Spécialités de dialyse',
    tooltip: `Affichage des résultats par spécialité de dialyse.`,
    filter: function (vm, u) {
      return u.uf === '__all__' && u.spe.match(/AD DIA ./)
    }
  },
  {
    name: 'UFs',
    tooltip: `Affichage des résultats par UFs.`,
    filter: function (vm, u) {
      return u.uf !== '__all__' && u.uf !== '__spe__'
    }
  },
  {
    name: 'Sélection manuelle',
    tooltip: `Sélectionner les lignes à afficher.`,
    filter: function (vm, u) {
      return vm.select.list.indexOf(u) !== -1
    },

    click: function (vm) {
      vm.select.showModal('list')
    }
  }
]

export default {
  infectionTypes: results.infectionTypes,
  scopes: scopes,
  denominators: results.extractDenominators(),
  specialities: results.specialities,
  types: results.establishments,
  filters: filters,
  entrances: results.extractAllEntrances(),
  qualities: results.qualities
}
